import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from '@wtag/react-comp-lib';
import './styles.scss';

const Loader = ({ text }) => (
  <div className="d-flex direction-column align-center justify-center row-gap-20">
    <Spinner bgColor="neutral" size="small" color="success" />
    <span className="issue-booking-loader__text">{text}</span>
  </div>
);

Loader.propTypes = {
  text: PropTypes.string.isRequired,
};

export default Loader;
